export default __webpack_public_path__ + "static/media/33.261f5f51.png";